"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeApiAdapter = void 0;
var events_1 = __importDefault(require("events"));
var log4js_1 = require("log4js");
var config_1 = require("./config");
/**
 * 创建 api adapter
 * @param options adapter 选项
 */
function makeApiAdapter(options) {
    var _a = options.data, data = _a === void 0 ? {} : _a, _b = options.methods, methods = _b === void 0 ? {} : _b, _c = options.configMeta, configMeta = _c === void 0 ? {} : _c, _d = options.installed, installed = _d === void 0 ? undefined : _d, _e = options.uninstalled, uninstalled = _e === void 0 ? undefined : _e, _f = options.used, used = _f === void 0 ? undefined : _f, _g = options.unused, unused = _g === void 0 ? undefined : _g, rest = __rest(options, ["data", "methods", "configMeta", "installed", "uninstalled", "used", "unused"]);
    var adapter = Object.assign(new events_1.default(), __assign(__assign(__assign(__assign({}, data), methods), rest), { configMeta: configMeta, configs: config_1.makeConfigs(options.configMeta), listening: false, logger: log4js_1.getLogger("adapter:" + options.id), __isApiAdapter: true }));
    if (typeof installed === 'function')
        adapter.on('installed', function () { return installed.apply(adapter); });
    if (typeof uninstalled === 'function')
        adapter.on('uninstalled', function () { return uninstalled.apply(adapter); });
    if (typeof used === 'function')
        adapter.on('used', function () { return used.apply(adapter); });
    if (typeof unused === 'function')
        adapter.on('unused', function () { return unused.apply(adapter); });
    return adapter;
}
exports.makeApiAdapter = makeApiAdapter;
